import React, { useState, Suspense, useContext, useEffect } from "react";
import { IconButton, Container, Divider, Grid, Typography, Box, Link } from "@mui/material";
import Draggable from "react-draggable";
import ConnectAccount from "./auth/ConnectToAccount";
import OpenDemoAccount from "./auth/OpenDemoAccount";
import { HiLink } from "react-icons/hi";
import { useTranslation } from 'react-i18next';
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';
import { ThemeContext } from "../../context/ThemeContext";
import CloseIcon from "@mui/icons-material/Close";
import UserName from "./auth/UserName";
import { getCompanyInfo } from "../../api/request/dashboard/dashboard";
import companyInfo from '../../companyInfo/companyInfo.json'

const TradingAccounts = ({ onClose }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("connect")
  const { darkMode } = useContext(ThemeContext)
  const handleTabChange = (tab) => setActiveTab(tab);
  const storedName = localStorage.getItem('username')
  const savedPassword = localStorage.getItem('password')
  const company = companyInfo.find(item => item.companyName === "Vertex Trader"); 
  const [companyData, setCompanyData] = useState(company);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCompanyInfo()
        if (!response.ok) throw new Error(`HTTP error! Status: ${response?.status}`);
        const data = await response.json();
        setCompanyData(data);
        console.log(data);

      } catch (err) {
        setError(err.message);
        // const company = companyInfo.find(item => item.companyName === "Vertex Trader");        
        // setCompanyData(company)
      }
    };
    fetchData();
  }, []);
  
  return (
    <>
      <Suspense fallback={<div>Loading translations...</div>}>
        {/* <LanguageSwitch /> */}
        <Container maxWidth="md" >
          <Draggable handle=".bg-primary">
            <div style={{ backgroundColor: darkMode ? '#0f1720' : 'var(--white)', boxShadow: darkMode ? "0px 16px 46px 8px rgba(0, 0, 0, 0.12);" : "0 10px 20px rgba(169, 169, 169, 0.3), 4px 4px 10px rgba(169, 169, 169, 0.2), -4px 4px 5px rgba(169, 169, 169, 0.1)", overflow: "hidden", width: "90%", position: "relative", }}>
              <div className="bg-primary" style={{ padding: "10px 15px", cursor: "move", }}>
                <Typography variant="body2" className="text-secondaryLight"> {t('title')}: {companyData?.companyName}</Typography>
                {onClose && (
                  <IconButton size="small" onClick={onClose} style={{ position: "absolute", top: "8px", right: "8px", color: "var(--white)", }}><CloseIcon sx={{ fontSize: '18px' }} /></IconButton>
                )}
              </div>
              <Grid container>
                <Grid item xs={4} style={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, }}>
                  <Grid container alignItems="center" spacing={1} sx={{ padding: '12px' }}>
                    <Grid item> <HiLink style={{ color: activeTab === "connect" ? "var(--primary)" : "var(--primary)", fontSize: '1.4rem' }} /></Grid>
                    <Grid item>
                      <Typography variant="body2" style={{ cursor: "pointer", }} onClick={() => handleTabChange("connect")} color={activeTab === "connect" ? "primary" : darkMode ? "var(--lightText)" : "var(--black)"}>{t('connectToAccount')}</Typography>
                    </Grid>
                  </Grid>
                  <Divider sx={{ borderColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)' }} />
                  <Grid container alignItems="center" spacing={1} sx={{ padding: '12px' }}>
                    <Grid item><PeopleAltTwoToneIcon style={{ color: "#2bbf53", fontSize: '1.4rem' }} /></Grid>
                    <Grid item>
                      <Typography variant="body2" style={{ cursor: "pointer" }} onClick={() => handleTabChange("demo")} color={activeTab === "demo" ? "primary" : darkMode ? "var(--lightText)" : "var(--black)"}>{t('openDemoAccount')}</Typography>
                    </Grid>
                  </Grid>
                  <Divider sx={{ borderColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)' }} />

                  {storedName && savedPassword && (
                    <>  <Grid container alignItems="center" spacing={1} sx={{ padding: "12px" }}>
                      <Grid item><PeopleAltTwoToneIcon style={{ color: "#ff8933", fontSize: '1.4rem' }} /></Grid>
                      <Grid item><Typography variant="body2" style={{ cursor: "pointer" }} onClick={() => handleTabChange("storedName")} color={activeTab === "storedName" ? "primary" : darkMode ? "var(--lightText)" : "var(--black)"}>{storedName}</Typography></Grid>
                    </Grid>
                      <Divider sx={{ borderColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)' }} />
                    </>
                  )}

                  <div style={{ position: "absolute", bottom: "10px", left: "10px", padding: '15px' }}>
                    <Box display='flex' flexDirection='column'>
                      <Typography variant="caption" className="text-gray1">2002-2025 Hybrid Solutions </Typography>
                      <Link href={companyData?.termsOfServiceUrl} target="_blank" variant="caption" className="text-primary" >{t('endUserAgreement')}</Link>
                      <Link href={companyData?.privacyPolicyUrl} target="_blank" variant="caption" className="text-primary" >{t('privacyPolicy')}</Link>
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={8} style={{ padding: "12px", paddingBottom: '3px' }}>
                  {activeTab === "connect" && <ConnectAccount companyData={companyData} />}
                  {activeTab === "demo" && <OpenDemoAccount companyData={companyData} />}
                  {activeTab === "storedName" && <UserName companyData={companyData} />}
                </Grid>
              </Grid>
            </div>
          </Draggable>
        </Container>
      </Suspense>
    </>
  );
};

export default TradingAccounts;
